// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"6f1c5083","644":"0173ca2c"}[chunkId] + ".chunk.js";
};